import { render, staticRenderFns } from "./MeasurementDocument.vue?vue&type=template&id=42b68570"
import script from "./MeasurementDocument.vue?vue&type=script&lang=ts"
export * from "./MeasurementDocument.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports